<script>
export default {
  name: 'BaseCheckbox',
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    modelValue: {
      type: [Boolean, Array],
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    id: { type: String, default: '' },
    name: { type: String, default: '' },
    label: { type: String, default: '' },
    customClass: { type: String, default: '' },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md', 'lg', 'xl', 'xxl'].includes(val),
    },
    sm: Boolean,
    md: Boolean,
    lg: Boolean,
    xl: Boolean,
    xxl: Boolean,
    disabled: { type: Boolean, default: false },
  },
  computed: {
    sizeClass() {
      if (this.xxl) return 'xxl'
      if (this.xl) return 'xl'
      if (this.lg) return 'lg'
      if (this.md) return 'md'
      if (this.sm) return 'sm'
      return this.size
    },
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value)
      }
      return !!this.modelValue
    },
  },
  methods: {
    handleChange(e) {
      const checked = e.target.checked

      if (Array.isArray(this.modelValue)) {
        const newValue = [...this.modelValue]
        const index = newValue.indexOf(this.value)

        if (checked && index === -1) {
          newValue.push(this.value)
        } else if (!checked && index !== -1) {
          newValue.splice(index, 1)
        }

        this.$emit('update:modelValue', newValue)
      } else {
        this.$emit('update:modelValue', checked)
      }

      this.$emit('change', checked)
    },
  },
  emits: ['update:modelValue'],
}
</script>

<template>
  <label class="custom-checkbox" :class="[sizeClass, { disabled }]">
    <input
      :id="id"
      type="checkbox"
      :name="name"
      :disabled="disabled"
      :class="customClass"
      :checked="isChecked"
      @change="handleChange"
    />
    <span class="checkmark"></span>
    <slot />
  </label>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/custom-checkbox.scss';
</style>
